import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function PageShell({ children, testId }) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <div key={location.pathname} data-testid={testId} className="page-transition">
      {children}
    </div>
  );
}
